<template>
    <div class="pda-default">
        <div class="mdc-card mdc-elevation--z3 pda-default">
            <div class="t-subtitle2">
                {{$t('1005')}}
                <!-- 시험 안내 -->
            </div>
            <div class="t-body3 mgt-16 t-color-bodyGrayA">
                {{summary}}
            </div>
        </div>

        <div class="mdc-card mdc-elevation--z3 mgt-16 pdb-20" v-if="periodPolicy">
            <div class="t-subtitle2 mgt-16 mgl-16 mgr-16 ">
                {{$t('1006')}}
                <!-- 기간 정보 -->
            </div>
            <div>
                <div class="d-flex flex-row pdt-24 mgl-8 mgr-8 t-body3">
                    <div class="pdl-8 pdr-8 flex-1 t-color-bodyGrayA">
                        {{$t('1007')}}
                        <!-- 시험 응시 기간 -->
                    </div>
                    <div class="pdl-8 pdr-8 flex-1">
                        {{$moment(periodPolicy.application.start).format('L')}}
                        ~
                        {{$moment(periodPolicy.application.end).format('L')}}
                    </div>
                </div>

                <div class="d-flex flex-row pdt-24 mgl-8 mgr-8 t-body3">
                    <div class="pdl-8 pdr-8 flex-1 t-color-bodyGrayA">
                        {{$t('1008')}}
                        <!-- 성적 조회 기간 -->
                    </div>
                    <div class="pdl-8 pdr-8 flex-1">
                        {{$moment(periodPolicy.scoreConfirm.start).format('L')}}
                        ~
                        {{$moment(periodPolicy.scoreConfirm.end).format('L')}}
                    </div>
                </div>
            </div>

            
        </div>
    </div>
</template>

<script>
export default {
    props: ['periodPolicy','summary'],

}
</script>

<style>

</style>